import React from 'react';
import parse from 'html-react-parser';

import Plyr from './plyr'

const VideoBlock = ({ alignment, caption, video, coverImage }) => {
  return (
    <section className="video-block">
      <div className={`video-block__inner video-block--${alignment}`}>
        <div className="video-block__wrapper">
          { video.indexOf('.mp4') !== -1 && 
            <video src={video} loop playsInline autoPlay muted /> 
          }
          { video.indexOf('.mp4') === -1 && 
            <Plyr
              provider={'youtube'}
              videoId={video}
              sources={[
                { src: video, type: 'video/mp4' }
              ]}
              poster={coverImage?.localFile?.childImageSharp?.original?.src}
              urls={{
                youtube: {
                  api: 'https://noembed.com/embed?url={0}'
                }
              }}
            />
          }
          { caption && <p>{parse(caption)}</p> }
        </div>
      </div>
    </section>
  );
};

export default VideoBlock;